// src/components/LoadingScreen.js

import React, { useEffect, useState } from "react";
import "components/LoadingScreen/LoadingScreen.css"; // Assuming you'll have separate CSS for this component
import config from "config.js";
import Polaroid from "components/Polaroid/Polaroid";

import loadingPolaroid from "assets/miscellaneous/loading_polaroid.svg";
import loadingSeal from "assets/background_images/Seal_watermark.svg";
import ErrorLion from "assets/lion_images/error_lion.png";

const BACKGROUNDS = [
  "dark-teal-bg",
  "dark-raspberry-bg",
  "dark-burnt-orange-bg",
  "olive-bg",
  "moss-green-bg",
];

const LoadingScreen = ({ setAppBackgroundColor, isVisible, showError }) => {
  const [currentFact, setCurrentFact] = useState(0);
  const [facts, setFacts] = useState([]);
  const [currentBackgroundIndex, setCurrentBackgroundIndex] = useState(0);
  const [timeoutInterval, setTimeoutInterval] = useState(7000); //the first fun fact will show for 5 seconds (factoring in the 2second delay of animaiton fade in)

  const fetchFacts = async () => {
    try {
      const response = await fetch(config.BACKEND_URL + "/data/fun-facts");
      if (!response.ok) {
        throw new Error("Failed to fetch Facts");
      }
      const data = await response.json();
      setFacts(data.funFacts);
    } catch (error) {
      console.error("Error fetching facts:", error);
    }
  };

  useEffect(() => {
    fetchFacts();
  }, []);

  useEffect(() => {
    if (isVisible) {
      //setBackground(`app ${BACKGROUNDS[currentBackgroundIndex]}`);
      setAppBackgroundColor(BACKGROUNDS[currentBackgroundIndex]);
      // Increment the background index in a circular manner
      setCurrentBackgroundIndex(
        (prevIndex) => (prevIndex + 1) % BACKGROUNDS.length
      );
    }
  }, [isVisible]);

  useEffect(() => {
    if (!facts || facts.length === 0 || !isVisible || showError) return;

    const intervalId = setInterval(() => {
      // Change the background
      setAppBackgroundColor(BACKGROUNDS[currentBackgroundIndex]);

      // Increment the background index in a circular manner
      setCurrentBackgroundIndex(
        (prevIndex) => (prevIndex + 1) % BACKGROUNDS.length
      );
      setCurrentFact((prevFact) => (prevFact + 1) % facts.length);
      setTimeoutInterval(3000);
    }, timeoutInterval); // Change fact every 3 seconds

    return () => clearInterval(intervalId);

  }, [facts, setAppBackgroundColor, currentBackgroundIndex, isVisible]); // Include isVisible as a dependency

  if (!isVisible) return null;
  if(showError) setAppBackgroundColor("dark-burnt-orange-bg");

  return (
    <div className={`loading-screen fact-${currentFact}`}>
      {showError ? (
         <div className="error-box">
         <img
               src={ErrorLion}
               alt="Error Lion"
             ></img>
         <h1>Whoops!</h1>
         <p>The AI system we're using didn't like something.</p>
         <a className="primary button" href={window.location}>Let's try again.</a> 
       </div>
      ) :(
        <div className="loading-graphic-container">
        <div className="loading-graphic">
          <img src={loadingPolaroid} alt="Loading Polaroid Image"></img>
        </div>
        <div className="fun-fact-container delayed-fade-in">
          <h1>{facts[currentFact].stat}</h1>
          <p className="fact-tagline">{facts[currentFact].tagline}</p>
          <p className="fact-source">{facts[currentFact].source}</p>
        </div>
      </div>
      )}
      <img
        className="loading-screen-background-seal"
        src={loadingSeal}
        alt="Gustavus Seal"
      ></img>
    </div>
  );
};

export default LoadingScreen;
